import { useEffect, useState } from "preact/hooks";

export const plainleafSkinStorageKey = "plainleaf.skin";
export const plainleafSkinChangeEvent = "plainleaf:skinchange";

export const plainleafSkins = ["classic", "cloudleaf"] as const;
export type PlainleafSkin = (typeof plainleafSkins)[number];

export const defaultPlainleafSkin: PlainleafSkin = "cloudleaf";

export const plainleafSkinLabels: Record<PlainleafSkin, string> = {
  classic: "简约原野",
  cloudleaf: "云叶冒险岛",
};

export function isPlainleafSkin(value: unknown): value is PlainleafSkin {
  return plainleafSkins.includes(value as PlainleafSkin);
}

export function readPlainleafSkin(): PlainleafSkin {
  try {
    const stored = globalThis.localStorage?.getItem(plainleafSkinStorageKey);
    return isPlainleafSkin(stored) ? stored : defaultPlainleafSkin;
  } catch {
    return defaultPlainleafSkin;
  }
}

export function applyPlainleafSkin(skin: PlainleafSkin): void {
  if (globalThis.document) {
    document.documentElement.dataset.skin = skin;
    globalThis.dispatchEvent?.(
      new CustomEvent<PlainleafSkin>(plainleafSkinChangeEvent, {
        detail: skin,
      }),
    );
  }
  try {
    globalThis.localStorage?.setItem(plainleafSkinStorageKey, skin);
  } catch {
    // Private browsing can disable persistent storage; the current document
    // still keeps the selected skin through its data attribute.
  }
}

export function usePlainleafSkin(): [
  PlainleafSkin,
  (skin: PlainleafSkin) => void,
] {
  const [skin, setSkinState] = useState<PlainleafSkin>(readPlainleafSkin);

  useEffect(() => applyPlainleafSkin(skin), [skin]);

  return [skin, setSkinState];
}
